import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLongFormBuilderOutlineSection,
  BackendMutationAcceptLongFormSectionContentArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation AcceptLongFormSectionContent($ids: [ID!]!) {
    acceptLongFormSectionContent(ids: $ids) {
      id
    }
  }
`;

type Variables = BackendMutationAcceptLongFormSectionContentArgs;
type Result = Pick<BackendLongFormBuilderOutlineSection, 'id'>[];

export const acceptLongFormSectionContent = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
